import { forwardRef, useState } from 'react'
import { Button, Icon } from '..'

interface InputFileProps {
  className?: string,
  type?: 'button',
  id?: string,
  name: string,
  accept?: string,
  butonText?: string,
  tabIndex?: number,
  multiple?: boolean,
  onChange(name: string, value: any): void,
  onError?(type: 'ERROR' | 'CLEAR', name?: any, value?: any): void
}

type Ref = HTMLInputElement;

const InputFile = forwardRef<Ref, InputFileProps>(({ className = '', type = 'button', id, name, accept = 'image/x-png,image/jpeg,application/pdf', butonText = '', tabIndex, multiple = false, onChange, onError }, ref) => {
  const [filesTags, setFilesTags] = useState<FileList | undefined>(undefined)

  const CFilesTags = () => {
    let fileTagsHtml: any[] = []

    if(filesTags === undefined) return null

    for (let i: number = 0; i < filesTags.length; i++) {
      const file = filesTags[i]

      fileTagsHtml.push(
        <div key={i} className={`input-file-tag`}>
          {file.name}
          <Icon name="file-delete" onClick={() => onFilesTagsDel(i)} />
        </div>
      )
    }

    return <>{fileTagsHtml}</>
  }

  const onBtnFileClick = (name: string) => {
    const inputFile = document.getElementById(name)

    if(inputFile) inputFile.click()
  }

  const onFileChange = (event: any) => {
    const { target: { name, files } } = event

    if(files && files[0]) {
      const fieldName: string = name
      const fileType = files[0].type
      const fileSize = files[0].size

      if(fileType && (fileType.indexOf('png') === -1 && fileType.indexOf('jpeg') === -1 && fileType.indexOf('pdf') === -1)) {
        if(onError) onError(
          'ERROR',
          fieldName,
          {
            type: 'format',
            message: 'Selecciona formato png, jpg o pdf'
          }
        )
        return ;
      } else if(fileSize && (fileSize / 1024 > 500)) {
        if(onError) onError(
          'ERROR',
          fieldName,
          {
            type: 'size',
            message: 'Selecciona tamaño maximo 500KB'
          }
        )
        return ;
      }

      setFilesTags(files)
      /*onChange(fieldName, files)*/

      if(onError) onError('CLEAR')
    }
  }

  const onFilesTagsDel = (index: number) => {
    setFilesTags(undefined)
    onChange(name, undefined)
  }

  return (
    <div className={`input-file ${className}`}>
      <Button
        size="md"
        borderRadius="4px"
        fullWidth
        tabIndex={tabIndex}
        onClick={() => onBtnFileClick(name)}
      >{butonText}</Button>
      <input
        ref={ref}
        type="file"
        id={id}
        name={name}
        accept={accept}
        multiple={multiple}
        onChange={onFileChange} />

      {filesTags && filesTags.length > 0 &&
        <div className="mt-10">
          <CFilesTags />
        </div>
      }
    </div>
  )
})

export { InputFile }